import React from "react";
import styled from "styled-components";

const FormButtonSecondary = ({ children, size, disabled, ...props }) => {

  if (size === "extraSmall") {
    return (
      <ButtonSecondaryExtraSmall disabled={disabled} $disabled={disabled} {...props}>
        {children}
      </ButtonSecondaryExtraSmall>
    );
  }

  if (size === "small") {
    return (
      <ButtonSecondarySmall disabled={disabled} $disabled={disabled} {...props}>
        {children}
      </ButtonSecondarySmall>
    );
  }

  return (
    <ButtonSecondary disabled={disabled} $disabled={disabled} {...props}>
      {children}
    </ButtonSecondary>
  );
};

const ButtonSecondary = styled.button`
  flex-shrink: 0;
  padding: 11px 60px;
  background-color: var(--aia-bx-white);
  color: var(--aia-bx-dark-blue);
  border: 1px solid var(--aia-bx-blue-2);
  border-radius: 100px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  visibility: visible;
  justify-content: center;
  
  display: flex;
  align-items: center;

  ${props => props.$disabled ? `
      cursor: not-allowed;
      opacity: 0.3;
      background-color: var(--aia-bx-gray-5);
      border-color: var(--aia-bx-gray-5);
      color: var(--aia-bx-gray-4);
    `
    :
    `
    &:hover {
      background-color: var(--aia-bx-blue-5);
    }
  `
  };
`;

const ButtonSecondarySmall = styled.button`
  flex-shrink: 0;
  padding: 8px 30px;
  background-color: var(--aia-bx-white);
  color: var(--aia-bx-dark-blue);
  border: 1px solid var(--aia-bx-blue-2);
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  line-height: 24px;
  font-weight: bold;
  visibility: visible;
  justify-content: center;

  display: flex;
  align-items: center;
  
  ${props => props.$disabled ? `
      cursor: not-allowed;
      opacity: 0.3;
      background-color: var(--aia-bx-gray-5);
      border-color: var(--aia-bx-gray-5);
      color: var(--aia-bx-gray-4);
    `
    :
    `
    &:hover {
      background-color: var(--aia-bx-blue-5);
    }
  `
  };
`;

const ButtonSecondaryExtraSmall = styled.button`
  flex-shrink: 0;
  padding: 5px 20px;
  background-color: var(--aia-bx-white);
  color: var(--aia-bx-dark-blue);
  border: 1px solid var(--aia-bx-blue-2);
  border-radius: 100px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  visibility: visible;
  justify-content: center;
  
  display: flex;
  align-items: center;
  
  ${props => props.$disabled ? `
      cursor: not-allowed;
      opacity: 0.3;
      background-color: var(--aia-bx-gray-5);
      border-color: var(--aia-bx-gray-5);
      color: var(--aia-bx-gray-4);
    `
    :
    `
    &:hover {
      background-color: var(--aia-bx-blue-5);
    }
  `
  };
`;

export default FormButtonSecondary;